module.exports = __webpack_public_path__ + "img/copon_06.6ca3352f.png";